angular
    .module('MyApp')
    .service('SeguroEducacionalService', ['$resource', '$q', 'Configs', '$http', 'SessionData', function($resource, $q, Configs, $http, SessionData) {
      
        var _msgErro = { msgErro: 'Error student undefined' };

        function _paramsSeguro() {
            return {
                codPessoaLogada: SessionData.user.id
            };
        }

        /**
         * Obtém os dados do seguro educacional para o aluno
         * @param {string} codAluno - Código do aluno
         * @returns {Promise} Promise com os dados do seguro
         */
        this.obterDadosSeguro = function(codAluno) {
            let defer = $q.defer();
            if (codAluno) {
                $http({
                    method: 'GET',
                    url: Configs.getApiServer() + '/seguro-educacional/aluno/' + encodeURIComponent(codAluno) + '/obter',
                    params: _paramsSeguro()
                })
                .then(function(response) {
                    defer.resolve(response.data);
                }, function(error) {
                    defer.reject(error);
                });
            } else {
                defer.reject(_msgErro);
            }
            return defer.promise;
        }

        /**
         * Realiza a adesão ao seguro educacional
         * @param {string} codAluno - Código do aluno
         * @returns {Promise} Promise com o resultado da adesão
         */
        this.aderirSeguro = function(codAluno) {
            let defer = $q.defer();
            if (codAluno) {
                $http({
                    method: 'POST',
                    url: Configs.getApiServer() + '/seguro-educacional/aluno/' + encodeURIComponent(codAluno) + '/aderir',
                    data: { codAluno: codAluno },
                    params: _paramsSeguro(),
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function(response) {
                    defer.resolve(response.data);
                }, function(error) {
                    defer.reject(error);
                });
            } else {
                defer.reject(_msgErro);
            }
            return defer.promise;
        }

        /**
         * Cancela a adesão ao seguro educacional
         * @param {string} codAluno - Código do aluno
         * @returns {Promise} Promise com o resultado do cancelamento
         */
        this.cancelarAdesao = function(codAluno) {
            let defer = $q.defer();
            if (codAluno) {
                $http({
                    method: 'POST',
                    url: Configs.getApiServer() + '/seguro-educacional/aluno/' + encodeURIComponent(codAluno) + '/cancelar',
                    data: { codAluno: codAluno },
                    params: _paramsSeguro(),
                    headers: { 'Content-Type': 'application/json' }
                })
                .then(function(response) {
                    defer.resolve(response.data);
                }, function(error) {
                    defer.reject(error);
                });
            } else {
                defer.reject(_msgErro);
            }
            return defer.promise;
        }
      
    }]);
